














































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { UserInfo } from "../../_models/userInfo";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { dispatchComuniList } from "../../_store/data.module";
import { ComuniInfo } from "../../_models/comuniInfo";

@Component
export default class EditUserInfoStepper extends Vue {
  @Prop() info!: UserInfo;
  private e1: number;
  private valid: boolean;
  private userType: string;
  private nomeUtente: string;
  private cognomeUtente: string;
  private indirizzoUtente: string;
  private telefono1Utente: string;
  private telefono2Utente: string;
  private cod: string;
  private dataNascita: string;
  private luogoNascita: string;
  private emailUtente: string;
  private pecUtente: string;
  private comuneUtente: string;
  private provinciaUtente: string;
  private entità: string;
  private idCap: number;
  private cap: string;

  private nomeRules: [boolean | string];
  private cognomeRules: [boolean | string];
  private codRules: [boolean | string];
  private emailRules: [boolean | string];
  private pecRules: [boolean | string];
  private comuneRules: [boolean | string];
  private tel1Rules: [boolean | string];
  private tel2Rules: [boolean | string];
  private luogoNascitaRules: [boolean | string];
  private capRules: [boolean | string];
  private indirizzoRules: [boolean | string];
  private dataRules: [boolean | string];

  // private model: object | null;
  private comuniStrings: string[];
  private comuni: any;
  private search: object | null;
  private isLoading: boolean;
  private searchLuogoNascita: object | null;

  constructor() {
    super();
    this.e1 = 0;
    this.valid = true;
    this.userType = "";
    this.nomeUtente = this.info.nomeUtente;
    this.cognomeUtente = this.info.cognomeUtente;
    this.indirizzoUtente = this.info.indirizzoUtente;
    this.telefono1Utente = this.info.telefono1Utente;
    this.telefono2Utente = this.info.telefono2Utente;
    this.cod = this.info.cod;
    this.dataNascita = this.info.dataNascita;
    this.luogoNascita = this.info.luogoNascita;
    this.emailUtente = this.info.emailUtente;
    this.pecUtente = this.info.pecUtente;
    this.comuneUtente = this.info.comuneUtente;
    this.provinciaUtente = this.info.provinciaUtente;
    this.entità = this.info.entità;
    this.idCap = this.info.idCap;
    this.cap = this.info.cap;

    this.nomeRules = [true];
    this.cognomeRules = [true];
    this.codRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.comuneRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.luogoNascitaRules = [true];
    this.capRules = [true];
    this.indirizzoRules = [true];
    this.dataRules = [true];

    // this.model = null;
    this.comuniStrings = [];
    this.comuni = [];
    this.search = null;
    this.isLoading = false;

    this.searchLuogoNascita = null;
  }

  @Watch("nomeUtente")
  onNomeUtenteChange(value: string) {
    this.nomeUtente = value.toUpperCase();
  }

  @Watch("cognomeUtente")
  onCognomeUtenteChange(value: string) {
    this.cognomeUtente = value.toUpperCase();
  }

  @Watch("search")
  onPropertyChanged(value: string) {
    if (this.comuni.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.comuni = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  @Watch("searchLuogoNascita")
  onLuogoNascitaChanged(value: string) {
    var comuniList: string[] = [];
    if (this.comuniStrings.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          response.forEach(element => {
            comuniList.push(element.località);
          });
          this.comuniStrings = comuniList;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  //metodi per la validazione degli input
  validazioneCognome() {
    var valid: boolean = false;
    if (this.cognomeUtente !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.cognomeUtente);
    }
    if (valid) {
      this.cognomeRules = [true];
    } else if (this.cognomeUtente === "") {
      this.cognomeRules = ["Cognome Utente necessario"];
    } else {
      this.cognomeRules = [
        "Cognome Utente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneNome() {
    var valid: boolean = false;
    if (this.nomeUtente !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.nomeUtente);
    }
    if (valid) {
      this.nomeRules = [true];
    } else if (this.nomeUtente === "") {
      this.nomeRules = ["Nome Utente necessario"];
    } else {
      this.nomeRules = [
        "Nome Utente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneCod() {
    var valid: boolean = false;
    if (this.cod !== "") {
      valid = /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/.test(
        this.cod
      );
    }
    if (valid) {
      this.codRules = [true];
    } else if (this.cod === "") {
      this.codRules = ["Codice fiscale necessario"];
    } else {
      this.codRules = [
        "Codice fiscale deve essere scritto con caratteri maiuscoli"
      ];
    }
  }
  validazioneEmail() {
    var valid: boolean = false;
    if (this.emailUtente !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailUtente
      );
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.emailUtente === "") {
      this.emailRules = ["Email Utente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }
  validazionePec() {
    var valid: boolean = false;
    if (this.pecUtente === "" || this.pecUtente === null) {
      this.pecRules = [true];
    } else {
      if (this.pecUtente !== "" && this.pecUtente !== null) {
        valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
          this.pecUtente
        );
      }
      if (valid) {
        this.pecRules = [true];
      } else {
        this.pecRules = ["Formato Pec non corretto"];
      }
    }
  }
  validazioneComune() {
    var valid: boolean = false;
    if (this.comuneUtente === "") {
      this.comuneRules = [true];
    } else {
      if (this.comuneUtente !== "") {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.comuneUtente);
      }
      if (valid) {
        this.comuneRules = [true];
      } else {
        this.comuneRules = ["Comune non può avere più di 50 caratteri"];
      }
    }
  }
  validazioneLuogoNascita() {
    var valid: boolean = false;
    if (this.luogoNascita === "") {
      this.luogoNascitaRules = [true];
    } else {
      if (this.luogoNascita !== "") {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.luogoNascita);
      }
      if (valid) {
        this.luogoNascitaRules = [true];
      } else {
        this.luogoNascitaRules = ["Comune non può avere più di 50 caratteri"];
      }
    }
  }
  validazioneTel() {
    var valid1: boolean = false;
    var valid2: boolean = false;
    if (this.telefono1Utente === "" || this.telefono1Utente === null) {
      this.tel1Rules = [true];
    } else {
      valid1 = /[0-9]{8,15}$/.test(this.telefono1Utente);
      if (valid1) {
        this.tel1Rules = [true];
      } else {
        this.tel1Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
    if (this.telefono2Utente === "" || this.telefono2Utente === null) {
      this.tel2Rules = [true];
    } else {
      valid2 = /[0-9]{8,15}$/.test(this.telefono2Utente);
      if (valid2) {
        this.tel2Rules = [true];
      } else {
        this.tel2Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
  }
  validazioneCap() {
    var valid: boolean = false;
    if (this.cap === "" || this.cap === null) {
      this.capRules = [true];
    } else {
      if (this.cap !== "" || this.cap !== null) {
        valid = /^[0-9]{5}$/.test(this.cap);
      }
      if (valid) {
        this.capRules = [true];
      } else {
        this.capRules = ["Formato Cap errato"];
      }
    }
  }
  validazioneIndirizzo() {
    var valid: boolean = false;
    if (this.indirizzoUtente === "" || this.indirizzoUtente === null) {
      this.indirizzoRules = [true];
    } else {
      if (this.indirizzoUtente !== "" || this.indirizzoUtente !== null) {
        valid = /^[a-zA-Z00-9ìèéùòà,.'\x20/-]{2,100}$/.test(
          this.indirizzoUtente
        );
      }
      if (valid) {
        this.indirizzoRules = [true];
      } else {
        this.indirizzoRules = [
          "Indirizzo non può avere più di 100 caratteri e non deve contenere caratteri speciali"
        ];
      }
    }
  }
  validazioneData() {
    var valid: boolean = false;
    if (this.dataNascita === "" || this.dataNascita === null) {
      this.dataRules = [true];
    } else {
      if (this.dataNascita !== "" || this.dataNascita !== null) {
        valid = /^[0-3]+[0-9]+\/[0-1]+[0-9]+\/[0-9]{4}$/.test(this.dataNascita);
      }
      if (valid) {
        this.dataRules = [true];
      } else {
        this.dataRules = ["La Data deve essere nel formato gg/mm/aaaa"];
      }
    }
  }
  async executeTestInfo() {
    this.validazioneCognome();
    this.validazioneNome();
    // this.validazioneCod();
    this.validazioneLuogoNascita();
    this.validazioneData();
  }
  async executeTestRecapiti() {
    this.validazioneEmail();
    this.validazionePec();
    this.validazioneComune();
    this.validazioneTel();
    this.validazioneCap();
    this.validazioneIndirizzo();
  }

  close() {
    this.nomeRules = [true];
    this.cognomeRules = [true];
    this.codRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.comuneRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.luogoNascitaRules = [true];
    this.capRules = [true];
    this.indirizzoRules = [true];
    this.dataRules = [true];
    bus.$emit("closeEditDialog");
    this.e1 = 1;
  }

  next() {
    this.executeTestInfo().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.e1 = 2;
      }
    });
  }

  back() {
    this.e1 = 1;
    this.emailRules = [true];
    this.pecRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.indirizzoRules = [true];
    this.comuneRules = [true];
    this.capRules = [true];
  }

  save() {
    this.executeTestRecapiti().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var payload: UserInfo = {
          tipoSoggetto: this.info.tipoSoggetto,
          ruoloUtente: this.info.ruoloUtente,
          descrizioneRuolo: this.info.descrizioneRuolo,
          nomeUtente: this.nomeUtente,
          cognomeUtente: this.cognomeUtente,
          indirizzoUtente: this.indirizzoUtente,
          telefono1Utente: this.telefono1Utente,
          telefono2Utente: this.telefono2Utente,
          cod: this.cod,
          dataNascita: this.dataNascita,
          //@ts-ignore
          luogoNascita: this.luogoNascita,
          emailUtente: this.emailUtente,
          pecUtente: this.pecUtente,
          comuneUtente: this.comuneUtente,
          provinciaUtente: this.provinciaUtente,
          entità: this.entità,
          codEntità: this.info.codEntità,
          idCap: this.idCap,
          idUtente: this.info.idUtente,
          cap: this.cap,
          username: this.info.username
        };
        user
          .dispatchEditUserInfo(this["$store"], payload)
          .then(() => {
            bus.$emit("editedUser");
            bus.$emit("successfullOperation", "Utente aggiornato con successo");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit(
                "errorOperation",
                "Errore nella modifica delle informazioni"
              );
            }
          });
      }
    });
  }
  created() {
    var comuniList: string[] = [];
    data
      .dispatchComuniList(this["$store"])
      .then(result => {
        result.forEach(element => {
          comuniList.push(element.località);
        });
        this.comuniStrings = comuniList;
        this.comuni = result;
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      });
  }
}
